import React, { useEffect, useState } from "react"
import { db, auth } from "./firebase"
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
  addDoc,
} from "firebase/firestore"

// 🚫 کلمات ممنوع
const bannedWords = ["sex", "fuck", "shit", "bitch"]

const containsBadWord = (text: string) => {
  return bannedWords.some((word) =>
    text.toLowerCase().includes(word)
  )
}

const Feed = ({ navigate }: { navigate: any }) => {
  const [posts, setPosts] = useState<any[]>([])
  const [comments, setComments] = useState<{ [key: string]: any[] }>({})
  const [commentText, setCommentText] = useState<{ [key: string]: string }>({})
  const [lastCommentTime, setLastCommentTime] = useState<number>(0)

  // 🔥 گرفتن پست‌ها
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "posts"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as any),
      }))

      // 🔥 رنکینگ
      const sorted = data.sort((a, b) => (b.likes || 0) - (a.likes || 0))
      setPosts(sorted)

      // 🔥 گرفتن کامنت‌ها
      sorted.forEach((post: any) => {
        onSnapshot(collection(db, "posts", post.id, "comments"), (snap) => {
          const c = snap.docs.map((d) => ({
            id: d.id,
            ...(d.data() as any),
          }))

          setComments((prev) => ({
            ...prev,
            [post.id]: c,
          }))
        })
      })
    })

    return () => unsub()
  }, [])

  // ❤️ لایک
  const handleLike = async (post: any) => {
    const userId = auth.currentUser?.uid
    if (!userId) return
    if (post.likedBy?.includes(userId)) return

    const ref = doc(db, "posts", post.id)

    await updateDoc(ref, {
      likes: (post.likes || 0) + 1,
      likedBy: [...(post.likedBy || []), userId],
    })
  }

  // 🚨 گزارش
  const handleReport = async (type: "post" | "comment", id: string) => {
    await addDoc(collection(db, "reports"), {
      type,
      targetId: id,
      reason: "user_reported",
      createdAt: Date.now(),
    })

    alert("Reported")
  }

  // 💬 کامنت
  const handleComment = async (postId: string) => {
    const text = commentText[postId]
    if (!text || text.trim().length < 2) return

    // ⛔ فیلتر محتوا
    if (containsBadWord(text)) return

    const now = Date.now()

    // ⛔ محدودیت 10 ثانیه
    if (now - lastCommentTime < 10000) return

    setLastCommentTime(now)

    await addDoc(collection(db, "posts", postId, "comments"), {
      text: text.trim(),
      createdAt: now,
      userId: auth.currentUser?.uid,
      flagged: containsBadWord(text),
    })

    setCommentText((prev) => ({
      ...prev,
      [postId]: "",
    }))
  }

  return (
    <div style={{ maxWidth: 700, margin: "40px auto", padding: 20, color: "white" }}>
      <h2>Confessions</h2>

      {posts.map((post) => {
        if (post.flagged) return null

        return (
          <div
            key={post.id}
            style={{
              background: "rgba(255,255,255,0.05)",
              padding: 20,
              borderRadius: 16,
              marginBottom: 20,
            }}
          >
            {/* متن */}
            <p>{post.text}</p>

            {/* لایک + ریپورت */}
            <div style={{ marginBottom: 10 }}>
              <button onClick={() => handleLike(post)}>
                ❤️ {post.likes || 0}
              </button>

              <button
                onClick={() => handleReport("post", post.id)}
                style={{
                  marginLeft: 10,
                  color: "red",
                  border: "none",
                  background: "transparent",
                  cursor: "pointer",
                }}
              >
                Report
              </button>
            </div>

            {/* کامنت‌ها */}
            <div>
              {(comments[post.id] || []).map((c) => {
                if (c.flagged) return null

                return (
                  <div key={c.id} style={{ fontSize: 13, opacity: 0.8 }}>
                    {c.text}

                    <button
                      onClick={() => handleReport("comment", c.id)}
                      style={{
                        marginLeft: 8,
                        color: "red",
                        border: "none",
                        background: "transparent",
                        cursor: "pointer",
                      }}
                    >
                      Report
                    </button>
                  </div>
                )
              })}
            </div>

            {/* input */}
            <input
              value={commentText[post.id] || ""}
              onChange={(e) =>
                setCommentText({
                  ...commentText,
                  [post.id]: e.target.value,
                })
              }
              placeholder="Write a comment..."
              style={{
                width: "100%",
                marginTop: 10,
                padding: 10,
                borderRadius: 10,
                border: "none",
              }}
            />

            <button
              onClick={() => handleComment(post.id)}
              style={{
                marginTop: 8,
                padding: "6px 12px",
                borderRadius: 20,
                border: "none",
                background: "white",
                color: "black",
              }}
            >
              Comment
            </button>
          </div>
        )
      })}
    </div>
  )
}

export default Feed